<template>
  <div v-tooltip="tooltip"
       class="marketing-email-form-models-item"
       @click="emitClick">
    <div class="marketing-email-form-models-item-img">
      <img class="marketing-email-form-models-item-img-src"
           :src="model.emailIcon" />
    </div>

    <p class="marketing-email-form-models-item-title">{{ title }}</p>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: undefined,
    },
  },

  components: {},

  computed: {
    title() {
      return this.model.label;
    },
    img() {
      return this.model.emailIcon;
    },
  },

  mounted() {},

  methods: {
    emitClick() {
      if (!this.disabled) {
        this.$emit("click");
      }
    },
  },

  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-email-form-models-item {
  border-radius: 20px;
  width: 250px;

  .marketing-email-form-models-item-img {
    position: relative;
    background: #f2f2f2;
    border-radius: 20px 20px 0 0;
    border: 1px solid #c2c2c2;
    height: 200px;
    overflow: hidden;

    .marketing-email-form-models-item-img-src {
      width: 100%;
      border-radius: 20px;
      border: 2px solid transparent;
      min-height: 100%;
    }
  }

  .marketing-email-form-models-item-title {
    text-align: center;
    margin: 0;
    color: #707070;
    font-size: 15px;
    padding: 30px 0 10px;
    margin-top: -20px;
    border-left: 1px solid #c2c2c2;
    border-bottom: 1px solid #c2c2c2;
    border-right: 1px solid #c2c2c2;
    border-radius: 0 0 20px 20px;
  }

  .marketing-email-form-models-item-img {
    &:hover {
      overflow: visible;
      cursor: pointer;
      border-radius: 20px;
      border-color: transparent;
      z-index: 1;

      .marketing-email-form-models-item-img-src {
        border: 2px solid $green-dark;
      }
    }
  }
}
</style>

